"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intentColor = intentColor;
exports.intentIcon = intentIcon;
exports.truncateMiddle = truncateMiddle;
exports.htmlElement = htmlElement;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("./colors");

var _index = require("../index");

var _iconNames = require("../components/icon/iconNames");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var intentColorMap = {
  danger: _colors.ColorAliases.DANGER,
  warning: _colors.ColorAliases.WARNING,
  success: _colors.ColorAliases.SUCCESS,
  primary: _colors.ColorAliases.PRIMARY
};

function intentColor(intent) {
  if (intent == null || intent === _index.Intent.NONE) {
    return undefined;
  }

  return intentColorMap[intent];
}

var intentIconMap = {
  danger: _iconNames.IconNames16.ERROR,
  warning: _iconNames.IconNames16.ERROR,
  success: _iconNames.IconNames16.SUCCESS,
  primary: _iconNames.IconNames16.ERROR
};

function intentIcon(intent) {
  if (intent == null || intent === _index.Intent.NONE) {
    return undefined;
  }

  return intentIconMap[intent];
}
/**
 * There are cases where important information is at the end of the string and truncating the end isn't helpful.
 * This function solves that.
 * @see https://github.com/kahwee/truncate-middle
 *
 * @param  {string} str         String to be truncated
 * @param  {number} frontLen    Number of characters to be remained in front.
 * @param  {number} backLen     Number of characters to be remained at the back.
 * @param  {string} truncateStr String that is replaced the truncated portion
 * @return {string}             Truncated string. Defaults to '&hellip;' if unspecified.
 */


function truncateMiddle(str, frontLen, backLen) {
  var truncateStr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&hellip;';

  if (str === null) {
    return '';
  }

  var strLen = str.length;

  if (frontLen === 0 && backLen === 0 || frontLen >= strLen || backLen >= strLen || frontLen + backLen >= strLen) {
    return str;
  }

  if (backLen === 0) {
    return str.slice(0, frontLen) + truncateStr;
  }

  return str.slice(0, frontLen) + truncateStr + str.slice(strLen - backLen);
}

function htmlElement(tagName, tagClassName) {
  return function (props) {
    var className = props.className,
        elementRef = props.elementRef,
        htmlProps = _objectWithoutProperties(props, ["className", "elementRef"]);

    return /*#__PURE__*/React.createElement(tagName, _objectSpread(_objectSpread({}, htmlProps), {}, {
      className: (0, _classnames.default)(tagClassName, className),
      ref: elementRef
    }));
  };
}